import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type {
  PageContent,
  PageContentCreate,
  PageContentFilter,
} from '../data/pageContent';

/**
 * Admin CRUD surface for the PageContent (CMS) entity. Mirrors CategoryService
 * — POST /Get, /all, /filter, /find, /Delete plus POST/PUT for create + update.
 * Storefront reads use the anonymous `publicCatalogService.getPage(slug)` path
 * instead; this service requires a JWT.
 */
export function createPageContentService(client: AxiosInstance) {
  return createCrudService<PageContent, PageContentCreate, PageContentFilter>(
    client,
    '/PageContent',
    'pageContentId',
  );
}

export type PageContentService = CrudService<
  PageContent,
  PageContentCreate,
  PageContentFilter
>;
